import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as c from '../constant';
import * as actions from '../action';

function UpdateModal({
  updateTaxRevenueTypes,
  getTaxRevenueTypesList,
  updateList,
  id,
  history,
  getSingleTaxRevenueTypes,
  updating,
}) {
  const [formData, setFormData] = useState({
    code: '',
    name: '',
    description: '',
    type: '',
    with_quarterly_calculation: 0,
    cumulative_amount_or: 0,
  });

  const validateForm = useFormValidator(formData, {
    code: 'required',
    name: 'required',
    type: 'required',
  });

  const handleDropDownChange = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
    };

    updateTaxRevenueTypes(id, args, ({ data }) => {
      setModal({ isOpen: false });
      getTaxRevenueTypesList();
      getSingleTaxRevenueTypes(id);
      history.push(`/bpls/settings/tax-revenue-types/${_.get(data, 'id')}`);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const onCheck = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked ? 1 : 0,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Code: {validateForm.renderMessage('code')}
            </label>
            <input
              className="form-control"
              type="text"
              name="code"
              onChange={onChange}
              value={_.get(formData, 'code')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Name: {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Description:
            </label>
            <input
              className="form-control"
              type="text"
              name="description"
              onChange={onChange}
              value={_.get(formData, 'description')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Type: {validateForm.renderMessage('type')}
            </label>
            <Select
              options={c.TYPES}
              placeholder="Select Tax Revenue Type"
              onChange={handleDropDownChange('type')}
              value={
                c.TYPES.filter(
                  (item) => _.get(formData, 'type') === _.get(item, 'value')
                ) || ''
              }
            />
          </div>
          <div className="col-12 form-group">
            <input
              name="with_quarterly_calculation"
              type="checkbox"
              checked={_.get(formData, 'with_quarterly_calculation')}
              onChange={onCheck}
            />
            <label htmlFor="last_name" className="full-label mb-0 ml-2">
              With Quarterly Calculation
            </label>
          </div>
          {_.get(formData, 'type') === 'MULTIPLE' ? (
            <div className="col-12 form-group">
              <input
                name="cumulative_amount_or"
                type="checkbox"
                checked={_.get(formData, 'cumulative_amount_or')}
                onChange={onCheck}
              />
              <label htmlFor="last_name" className="full-label mb-0 ml-2">
                Cumulative Amount in View OR
              </label>
            </div>
          ) : (
            ''
          )}
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={updating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  updateList: PropTypes.instanceOf(Object).isRequired,
  updateTaxRevenueTypes: PropTypes.instanceOf(Function).isRequired,
  getTaxRevenueTypesList: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleTaxRevenueTypes: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_TAX_REVENUE_TYPES) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
